import React from "react";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableColumn = (props) => {
  const { id, size, children } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    flexBasis: `${(size / 12) * 100}%`,
    transition,
    transform: CSS.Transform.toString(transform),
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="sortable-column flex-shrink-0"
      {...attributes}
    >
      <div className="sortable-column-draggable" {...listeners}></div>
      {children}
    </div>
  );
};